module.exports = __webpack_public_path__ + "static/media/IMG_6421.89ea7e09.JPG";